module.exports = __webpack_public_path__ + "static/media/planta-final03.71c7b742.jpg";